import { isCompassFeatureFlagEnabled } from "@me8eon/compass_data_plugin";
import { SourceSelector, SourceSelectorRef } from "./SourceSelector"
import React, { forwardRef, useEffect, useMemo } from "react";
import { useTranslation } from "@me8eon/translation";
import { useFeatureFlags } from "@me8eon/featureflags";
import { useUserData } from "@me8eon/react_authentication";

interface SampleSelectorProps {
    onChange?: (res: any) => void;
    defaultValue?: string;
}

export const SampleSelector = forwardRef<SourceSelectorRef, SampleSelectorProps>(({ onChange, defaultValue }, ref) => {
    const t = useTranslation();
    const [featureFlags] = useFeatureFlags();
    const { featureFlagEnabled, empType } = useUserData();
    const [defaultSourceObj, setDefaultSourceObj] = React.useState<string>("");
    const compassFeatureFF = isCompassFeatureFlagEnabled(empType);

    const sourceItems = useMemo(() => [
        {
            id: "all",
            label: t("sourceSelector.allSources"),
            name: "All sources",
            description: t("sourceSelector.allSourcesDesc")
        },
        {
            id: "eon-kb",
            label: t("sourceSelector.eonKnowledgeBase"),
            name: "E.ON Knowledge Base",
            description: t("sourceSelector.eonKnowledgeBaseDesc")
        },
        {
            id: "eon-my-it",
            label: t("sourceSelector.eonMyItOrder"),
            name: "E.ON My IT Order",
            description: t("sourceSelector.eonMyItOrderDesc")
        },
        {
            id: "my-genius",
            label: t("sourceSelector.myGenius"),
            name: "E.ON MyGenius",
            description: t("sourceSelector.myGeniusDesc")
        },
        {
            id: "eon-apps",
            label: t("sourceSelector.eonApps"),
            name: "E.ON Apps",
            description: t("sourceSelector.eonAppsDesc")
        },
        {
            id: "eon-it-kb",
            label: t("sourceSelector.eonItKnowledgeBase"),
            name: "E.ON IT Knowledge Base",
            description: t("sourceSelector.eonItKnowledgeBaseDesc")
        },
        ...(featureFlagEnabled ? [
            {
                id: "confluence-all",
                label: t("sourceSelector.confluenceAll"),
                name: "Confluence",
                description: t("sourceSelector.confluenceAllDesc")
            },
            {
                id: "sharepoint-all",
                label: t("sourceSelector.sharepointAll"),
                name: "E.ON SharePoint",
                description: t("sourceSelector.sharepointAllDesc")
            },
        ] : []),
        {
            id: "hr-policies",
            label: t("sourceSelector.hrPolicies"),
            name: "HR Policies",
            description: t("sourceSelector.hrPoliciesDesc")
        },
        ...(compassFeatureFF ? [{
            id: "compass",
            label: t("sourceSelector.compass"),
            name: "Compass",
            description: t("sourceSelector.compassDesc"),
            enabled: localStorage.getItem("admin") === "true"
        }] : []),
    ], [t, featureFlagEnabled, featureFlags]);

    useEffect(() => {
        if (!sourceItems.length) return;
        const selected =
            sourceItems.find(item => item.name === defaultValue) ?? sourceItems[0];
        const { id, label, name } = selected;
        setDefaultSourceObj(JSON.stringify({ id, label, name }));
    }, [defaultValue, sourceItems]);

    return (
        <SourceSelector
            ref={ref}
            sources={sourceItems}
            triggerLabel={t("sourceSelector.title")}
            enableDetailSearch
            defaultSelectedSourceId={defaultSourceObj}
            defaultDetailSelections={{}}
            onChange={onChange}
        />
    )
});
